import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
    const { language } = useLanguage();

    const t = (es: string, en: string) => language === 'es' ? es : en;

    const handleEmailClick = () => {
        window.location.href = 'mailto:info@PrinconserKids.com';
    };

    return (
        <footer className="bg-gradient-to-r from-gray-900 via-blue-900 to-purple-900 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 lg:py-12">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
                    {/* Información de la empresa */}
                    <div className="space-y-4">
                        <h3 className="text-xl sm:text-2xl font-bold font-['Dancing_Script'] text-yellow-400">
                            Princonser Kids
                        </h3>
                        <p className="text-sm sm:text-base text-gray-300 leading-relaxed">
                            {t(
                                'Transformando el futuro de la educación infantil a través de metodologías filosóficas innovadoras y tecnología de vanguardia.',
                                'Transforming the future of children\'s education through innovative philosophical methodologies and cutting-edge technology.'
                            )}
                        </p>
                    </div>

                    {/* Información de contacto */}
                    <div className="space-y-4">
                        <h4 className="text-base sm:text-lg font-semibold text-yellow-400">
                            {t('Contacto', 'Contact')}
                        </h4>
                        <div className="space-y-3">
                            <div className="flex items-start space-x-3">
                                <div className="text-yellow-400 mt-1">🏢</div>
                                <div>
                                    <p className="font-medium">Multitest Solutions LLC</p>
                                    <p className="text-gray-300 text-sm">
                                        7901 4th St N Ste 300<br />
                                        St. Petersburg, FL 33702
                                    </p>
                                </div>
                            </div>
                            
                            <div className="flex items-center space-x-3">
                                <div className="text-yellow-400">📞</div>
                                <div className="text-gray-300">
                                    +1 (305) 518 5322
                                </div>
                            </div>
                            
                            <div className="flex items-center space-x-3">
                                <div className="text-yellow-400">✉️</div>
                                <button
                                    onClick={handleEmailClick}
                                    className="text-gray-300 hover:text-yellow-400 transition-colors duration-200"
                                >
                                    info@PrinconserKids.com
                                </button>
                            </div>
                        </div>
                    </div>


                </div>

                {/* Línea divisoria */}
                <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-3 sm:space-y-4 md:space-y-0">
                        <p className="text-gray-400 text-sm">
                            © 2024 Multitest Solutions LLC. {t('Todos los derechos reservados.', 'All rights reserved.')}
                        </p>
                        <div className="flex space-x-6">
                            <a 
                                href="#" 
                                className="text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                                title={t('Política de Privacidad', 'Privacy Policy')}
                            >
                                {t('Privacidad', 'Privacy')}
                            </a>
                            <a 
                                href="#" 
                                className="text-gray-400 hover:text-yellow-400 transition-colors duration-200"
                                title={t('Términos de Servicio', 'Terms of Service')}
                            >
                                {t('Términos', 'Terms')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 